import ArticleBrief from './articleBrief'

if (document.querySelector('#article-userActionsBrief')) {
	const articleBrief = new ArticleBrief()
	articleBrief.init()
}
